<template>
	<o-nav-main
		:ref="setup._navAside"
		:key="setup.asideNavigation.length"
		class="arm-nav-menu shared-aside-navigation"
		:items="setup.asideNavigation">
		<template #default="{ item }">
			<div
				class="arm-nav-menu__item"
				:class="{
					'arm-nav-menu__item--parent': item.children?.length || setup.self.isTempWorker(),
					'arm-nav-menu__item--section-title': item.sectionTitle,
				}">
				{{ item.label }}
				<span
					v-if="item.marker"
					class="marker"
					:class="{ 'marker__number': typeof item.marker === 'number' }">{{ typeof item.marker === 'number' ? item.marker : null }}</span>
			</div>
		</template>
	</o-nav-main>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedAsideNavigationEmits, SharedAsideNavigationProps } from './SharedAsideNavigationSetup';
import SharedAsideNavigationSetup from './SharedAsideNavigationSetup';
const emits = defineEmits<SharedAsideNavigationEmits>() as SharedAsideNavigationEmits;
const props = withDefaults(defineProps<SharedAsideNavigationProps>(), SharedAsideNavigationSetup.defaultProps);
const setup = new SharedAsideNavigationSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins";

.shared-aside-navigation {
	.arm-nav-menu__item {
		position: relative;
	}
}

.marker {
	position: absolute;
	top: -0.25rem;
	right: -1rem;
	font-size: 0.75rem;
	color: white;
	background-color: var(--danger);
	.circle(0.5rem);

	&__number {
		top: -0.5rem;
		right: -1.5rem;
		display: flex;
		justify-content: center;
		.circle(1rem);
	}
}
</style>
